import { createServiceClient } from "shared/welda/services/axiosClient";

const apiDias = createServiceClient("/dias");

const SyncDataSagetoDoc = async (diasData) =>
  await apiDias.get("/SyncDataSagetoDoc", {
    params: diasData,
  });

const SyncLevTypetoDoc = async (diasData) =>
  await apiDias.get("/SyncLevTypetoDoc", {
    params: diasData,
  });

const GetAutomaticFollowups = async (diasData) =>
  await apiDias.post("/GetAutomaticFollowups", diasData);

const OfferCustomerStats = async (diasData) =>
  await apiDias.post("/OfferCustomerStats", diasData);

const OfferManagerStats = async (diasData) =>
  await apiDias.post("/OfferManagerStats", diasData);

const GetCustomerStructure = async (diasData) =>
  await apiDias.get("/GetCustomerStructure", {
    params: diasData,
  });

/**
 * Sends a registration-link email to the customer for a given webshop (dossier).
 * @param {{ contactObjId: number, dossierNr: number, email?: string }} payload - email is optional; if omitted, backend uses contact's email
 */
const SendCustomerRegistrationLink = async (payload) =>
  await apiDias.post("/sendCustomerRegistrationLink", payload);

const GetCustomers = async (diasData) =>
  await apiDias.post("/GetCustomers", diasData);

const getCustomerByERPklaNr = async (klantnr) =>
  await apiDias.get("/GetCustomerByERPklaNr", {
    params: { klantnr },
  });

const QueryDocuments = async (diasData) =>
  await apiDias.post("/QueryDocuments", diasData);

const SearchContacts = async (diasData) =>
  await apiDias.get("/searchContacts", {
    params: diasData,
  });

const dataDrop = async (diasData) =>
  await apiDias.get("/datadrop", {
    params: diasData,
  });

const GetMapData = async (diasData) =>
  await apiDias.get("/GetMapData", {
    params: diasData,
  });

const UpdateDocument = async (diasData) =>
  await apiDias.post("/UpdateDocument", diasData);

const CreateDocument = async (diasData) =>
  await apiDias.post("/CreateDocument", diasData);

const CreateUpdateContactAsync = async (diasData) =>
  await apiDias.post("/CreateUpdateContactAsync", diasData);

const DownloadDocument = async (diasData) => {
  const data = await apiDias.get("/DownloadDocument", {
    params: diasData,
  });

  return { base64: data, filename: diasData.Filename };
};

/** Employee herstelstaat by dossier + HRB doknr (DIAS HRSTSTT / HRSTBON). */
const DownloadHerstelstaat = async ({ dossierNr, doknr, download = false }) => {
  const params = {
    o: dossierNr,
    d: doknr,
  };
  if (download) {
    params.download = "1";
  }
  return await apiDias.get("/employee/herstelstaat", { params });
};

const DownloadDocuments = async ({ documents }) => {
  const data = await apiDias.post("/DownloadDocuments", {
    documents,
  });
  return data;
};

const DownloadPublicDocumentExtra = async (diasData) => {
  const data = await apiDias.get("/DownloadPublicDocument", {
    params: diasData,
  });

  return { base64: data, filename: diasData.Filename };
};

const DownloadPublicDocument = async (diasData) =>
  await apiDias.get("/public/DownloadDocument", {
    params: diasData,
  });

const GetProductDocuments = async () =>
  await apiDias.get("/public/ProductDocuments");

const GetProductDocumentsByRefs = async ({ refs }) =>
  await apiDias.post("/public/ProductDocumentsByRefs", { refs });

const GetDocTypeTranslation = async ({ code, ref } = {}) =>
  await apiDias.get("/doc-type-translation", {
    params: { code, ref },
  });

const GetDocumentPagePreviews = async ({
  diasDocumentRef,
  dossierNr,
  fromPage,
  toPage,
}) =>
  await apiDias.post("/document-page-previews", {
    diasDocumentRef,
    dossierNr,
    fromPage,
    toPage,
  });

const diasService = {
  GetCustomerStructure,
  SendCustomerRegistrationLink,
  GetCustomers,
  QueryDocuments,
  UpdateDocument,
  CreateDocument,
  DownloadDocument,
  DownloadHerstelstaat,
  CreateUpdateContactAsync,
  DownloadPublicDocument,
  SearchContacts,
  dataDrop,
  GetMapData,
  GetAutomaticFollowups,
  OfferCustomerStats,
  OfferManagerStats,
  SyncDataSagetoDoc,
  SyncLevTypetoDoc,
  getCustomerByERPklaNr,
  DownloadDocuments,
  DownloadPublicDocumentExtra,
  GetProductDocuments,
  GetProductDocumentsByRefs,
  GetDocTypeTranslation,
  GetDocumentPagePreviews,
};

export default diasService;
